module.exports = __webpack_public_path__ + "files/1e1bf3f1aa20dd982f1817149f6d2625.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/activity-1.png
// module id = 1611
// module chunks = 60